import axios from 'axios';

const REQUEST_PREFIX = 'https://mir-svc-api.nyanblock.com:12000';

export async function checkPassword(password) {
  const formData = new FormData();
  formData.set('password', password);
  try {
    const response = await axios({
      method: 'post',
      url: `${REQUEST_PREFIX}/auth`,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    if (response.status === 200) return true;
    return false;
  } catch (error) {
    return false;
  }
}

export async function convertSingingVoice({ password, email, target, source }) {
  const formData = new FormData();
  formData.set('password', password);
  formData.set('email', email);
  formData.set('target', target);
  formData.set('source', source);
  try {
    const response = await axios({
      method: 'post',
      url: `${REQUEST_PREFIX}/convert`,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    if (response.status === 200) return {
      success: true,
      position: response.data.position
    };
    return {
      success: false
    };
  } catch (error) {
    return {
      success: false
    };
  }
}